import countly from "./countly";

import { useCallback } from "react";

export function useAnalytics() {
    const trackEvent = useCallback((key, segmentation) => {
        countly.event(key, segmentation);
    }, []);

    const trackPageView = useCallback((pageName) => {
        countly.pageView(pageName);
    }, []);

    const setAnalyticsUser = useCallback((userData) => {
        countly.setUser(userData);
    }, []);

    const clearAnalyticsUser = useCallback(() => {
        countly.clearUser();
    }, []);

    return { trackEvent, trackPageView, setAnalyticsUser, clearAnalyticsUser };
}
